import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";

@Injectable({
    providedIn:'root'
})
export class FiltersService {

    public subject = new Subject<any>();
    
    sendClickEvent(object: any){
        this.subject.next(object);
    }

    getClickEvent():Observable<any>{
        return this.subject.asObservable();
    }
}
